import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "@/lib/data";
import { useLang } from "@/i18n";

/**
 * Apple-style pinned moment: a full-viewport image stays fixed while a large
 * statement scales and fades as the visitor scrolls through, then releases
 * into the next section. Uses existing brand phrasing only.
 */
const CinematicStatement = () => {
  const ref = useRef(null);
  const { t } = useLang();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });

  const imgScale = useTransform(scrollYProgress, [0, 1], [1.15, 1.3]);
  const textScale = useTransform(scrollYProgress, [0, 0.5, 1], [0.9, 1, 1.1]);
  const textOpacity = useTransform(scrollYProgress, [0, 0.18, 0.7, 0.95], [0, 1, 1, 0]);
  const overlay = useTransform(scrollYProgress, [0, 0.5, 1], [0.55, 0.65, 0.8]);

  return (
    <section ref={ref} className="relative h-[220vh] bg-[#0d1f12]">
      <div className="sticky top-0 h-screen w-full overflow-hidden flex items-center justify-center">
        <motion.img
          src={IMAGES.orchardRows}
          alt="Sunlit high-density apple orchard rows"
          style={{ scale: imgScale }}
          className="absolute inset-0 w-full h-full object-cover"
        />
        <motion.div style={{ opacity: overlay }} className="absolute inset-0 bg-[#0d1f12]" />
        <motion.h2
          style={{ scale: textScale, opacity: textOpacity }}
          className="relative z-10 text-center font-display font-semibold tracking-tight text-white leading-[1.05] text-4xl sm:text-6xl lg:text-[6vw] px-6"
        >
          {t("cine.l1")}<br />{t("cine.l2pre")} <span className="italic text-[#e7c46b]">{t("cine.l2accent")}</span>
        </motion.h2>
      </div>
    </section>
  );
};

export default CinematicStatement;
